export default function(h, row, index) {
    let _comments = '';

    // +    comments_text           Агентство - Комментарии менеджера
    // +    comments_for_drive      Агентство - Комментарии к водителям
    // +    sys_comments_canceled   Агентство - Комментарии к аннулированию
    // +    ag_comments_buh         Агентство - Комментарии бухгалтерии
    // sys_comments_refuse                 НСБ - Комментарий к отказу

    if ((row.comments_text != null)&&(row.comments_text != '')) {
        return <span title="Комментарий от менеджера"><strong>М:</strong> {row.comments_text}</span>
    }
    // if ((row.sys_comments_canceled != null)&&(row.sys_comments_canceled != '')) {
    //     _comments .= _comments ? '<br>' : '';
    //     _comments .= <span title="Комментарий к отказу"><string>О</string>{row.sys_comments_canceled}</span>
    // }

    return ''
}